<template>
  <v-card flat>
    <v-layout column class="text-sm-center d-flex align-center">
      <v-icon class="mr-2">mdi-image-broken</v-icon>
      <p>We can't generate preview for this file.</p>
      <p>Try to download the file to view it.</p>
      <v-btn color="primary" class="ml-2" download @click="handleDownload">
        Download
      </v-btn>
    </v-layout>
  </v-card>
</template>

<script>
import Storage from '@/storage'

export default {
  props: {
    url: String,
    title: String
  },
  data () {
    return {
      storage: null
    }
  },
  mounted () {
    this.storage = new Storage()
  },
  methods: {
    handleDownload () {
      const key = decodeURIComponent(this.url.split('?X-Amz')[0].split('/').slice(3).join('/'))
      this.storage
        .getAttachmentUrl(key)
        .then((signedURL) => {
          const link = document.createElement('a')
          link.href = signedURL
          link.download = this.title
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        })
    }
  }
}
</script>
